export const ENDPOINTS = {
  /** Ручки для работы с авторизацией и данными пользователя */
  user: {
    login: 'user.login',
    current: 'user.current',
    logout: 'user.logout',
  },
  /** Ручки для работы с формами */
  form: {
    formList: 'form.list',
    fieldsList: 'form.fields_list',
    create: 'form.create',
    formFields: 'form.fields',
    get: 'form.get',
    update: 'form.update',
    actions: 'form.actions.get',
    actionsExecute: 'form.actions.execute',
    tableDataUpload: 'form.table_data.upload',
    export: 'form.export',
    exportData: 'form.export_data',
    tableHeader: 'form.table_header',
    tableData: 'form.table_data',
    aggregation: 'form.aggregation_get',
    tableDataUpdate: 'form.table_data.update',
    pollUpdate: 'form.poll_update',
    remove: 'form.remove',
    activities: {
      get: 'form.table_data.activities.get',
      add: 'form.table_data.activities.add',
      edit: 'form.table_data.activities.edit',
      delete: 'form.table_data.activities.delete',
    },
    notification: {
      send: 'form.notification.send',
      list: 'form.notification.list',
      get: 'form.notification.get',
      recipientsCount: 'form.notification.recipients_count',
    },
  },
  /** Ручки для работы с полем типа "Справочник" */
  enum: {
    get: 'enum.get',
    update: 'enum.update',
  },
};
